import { KpiCard } from "@/components/common/KpiCard"
import { DASHBOARD_KPIS } from "../dashboard-config"

export function KpiSection() {
  return (
    <section className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {DASHBOARD_KPIS.map((kpi) => (
        <KpiCard key={kpi.label} {...kpi} />
      ))}
    </section>
  )
}
